import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequsetForm.XeroAirwallexBatchPaymentForm', {
    noAvailableSourceCurrency:
        'No available source currency for selected combination of bill currency and beneficiary bank account currency.',
    saveAndSubmitRequestSuccess: 'The request is submitted for approval.',
});
